/* Marketing v2 — backend içerik yükleyici.
   Tasarımın content.js / feature-data.js / solution-data.js yerine geçer:
   /api/websitev2 uçlarından çekip window.MKT.content / featureDetails / flows /
   solutionDetails / storefronts'u AYNI şekilde doldurur (App ilk render'dan ÖNCE). */

const API_BASE = (process.env.REACT_APP_BASE_URL || "http://localhost:5000").replace(/\/$/, "");

const get = (path) =>
  fetch(API_BASE + "/api/websitev2" + path)
    .then((r) => r.json())
    // Backend websitev2 uçları çıplak dizi/nesne (Ok(...)) dönüyor; app uçları ise
    // KomutResponse zarfı (Success → {Result}). İkisini de destekle.
    .then((d) => (d && d.Result !== undefined ? d.Result : d) || null)
    .catch(() => null);

// "website" modülü özellik sayfasındaki vitrin arketipleri (statik pazarlama kopyası).
const STOREFRONTS = [
  { name: "Classic · Trust", color: "#2e78bc", icon: "bike", sector: { en: "Bike & city rental", tr: "Bisiklet & şehir kiralama" }, copy: { en: "A reassuring, structured layout that earns instant trust from city cyclists and tourists. Optimised to rank for “bike rental near me” and turn first-time visitors into booked riders.", tr: "Şehirli bisikletçiler ve turistlerden anında güven kazandıran düzenli, güven veren bir düzen. “Yakınımda bisiklet kiralama” aramalarında öne çıkmak ve ilk ziyaretçiyi rezervasyona çevirmek için optimize edildi." } },
  { name: "Bold · Conversion", color: "#e2622a", icon: "zap", sector: { en: "Scooter & e-mobility", tr: "Scooter & e-mobilite" }, copy: { en: "A high-contrast hero with a one-tap booking widget engineered to convert impulse riders on the spot. Ideal for busy tourist hotspots where speed and clarity win the booking.", tr: "Anlık müşteriyi yerinde dönüştürmek için tasarlanmış tek dokunuşlu rezervasyon alanına sahip yüksek kontrastlı bir hero. Hız ve netliğin kazandırdığı yoğun turistik noktalar için ideal." } },
  { name: "Editorial · Premium", color: "#0f8d54", icon: "caravan", sector: { en: "Caravan & RV rental", tr: "Karavan & RV kiralama" }, copy: { en: "Magazine-style visuals that make every motorhome feel like a getaway worth paying for. Attracts higher-value, longer bookings and ranks for searches like “campervan hire”.", tr: "Her motorhome’u, parasını hak eden bir kaçamak gibi gösteren dergi tarzı görseller. Daha yüksek değerli, daha uzun rezervasyonlar çeker ve “karavan kiralama” gibi aramalarda öne çıkar." } },
  { name: "Minimal · Light", color: "#2196d6", icon: "package", sector: { en: "Equipment & devices", tr: "Ekipman & cihazlar" }, copy: { en: "Clean, fast, distraction-free pages that put your gear and prices front and centre. They load quickly for SEO and convert shoppers who are comparing rental options.", tr: "Ekipmanınızı ve fiyatları ön plana çıkaran sade, hızlı ve dikkat dağıtmayan sayfalar. SEO için hızlı yüklenir ve kiralama seçeneklerini karşılaştıran müşterileri dönüştürür." } },
  { name: "Playful · Active", color: "#7a4ddb", icon: "mountain-snow", sector: { en: "Events & sports", tr: "Etkinlik & spor" }, copy: { en: "An energetic, colourful design that matches the fun of festivals, ski trips and outdoor adventures. Perfect for seasonal campaigns and social-driven traffic that needs to convert fast.", tr: "Festivallerin, kayak tatillerinin ve açık hava maceralarının enerjisine uyan canlı, renkli bir tasarım. Hızlı dönüşmesi gereken sezonsal kampanyalar ve sosyal medya trafiği için ideal." } },
  { name: "Bounce · Party", color: "#e2487f", icon: "party-popper", sector: { en: "Inflatable party rental", tr: "Şişme parti kiralama" }, copy: { en: "A bright, joyful storefront that parents love and kids point at, building instant excitement. Captures “bouncy castle hire” searches and books out your weekends fast.", tr: "Ebeveynlerin bayıldığı, çocukların işaret ettiği, anında heyecan yaratan parlak ve neşeli bir vitrin. “Şişme kale kiralama” aramalarını yakalar ve hafta sonlarınızı hızla doldurur." } },
  { name: "Drive · Auto", color: "#1d4f86", icon: "car-front", sector: { en: "Car rental", tr: "Araç kiralama" }, copy: { en: "A sleek, premium dark theme that signals reliability across every class of vehicle. Built to win “car rental” searches and upsell SUVs and sports models at checkout.", tr: "Her araç sınıfında güvenilirliği yansıtan şık, premium koyu bir tema. “Araç kiralama” aramalarını kazanmak ve ödeme adımında SUV ve spor modellere yönlendirmek için tasarlandı." } },
  { name: "Marine · Luxe", color: "#0f8d54", icon: "sailboat", sector: { en: "Yacht & boat rental", tr: "Yat & tekne kiralama" }, copy: { en: "An elegant, aspirational design that sells the dream of a day out on the water. Attracts premium clients and ranks for high-intent searches like “yacht charter” and “boat hire”.", tr: "Suda geçirilecek bir günün hayalini satan zarif, ilham veren bir tasarım. Premium müşteriler çeker ve “yat kiralama”, “tekne kiralama” gibi yüksek niyetli aramalarda öne çıkar." } },
];


/* =====================================================================
   D-212 F3+F4 — gömülen veriyi küçültme

   Sorun: react-snap her sayfaya `window.__MKT__` olarak SİTENİN TÜM
   İÇERİĞİNİ, SEKİZ DİLDE birden gömüyordu (1.831 KB, HTML'in %92-98'i).

   Çözüm iki adımlı:
     F3  dil dilimleme — /tr/… sayfası yalnız `tr` taşır (8'e bölünür)
     F4  sayfa kapsamı — ağır detay alanları (blog/yardım/sözleşme gövdeleri,
         modül caps+flows, çözüm detayları) YALNIZ o sayfanın kaydında kalır

   Kural: prerender edilmiş DOM tam veriyle çizilir ve HİÇ DEĞİŞMEZ. Burada
   küçülen şey yalnız hidrasyon için gömülen kopya. Bu yüzden dilimleme,
   bileşenlerin kullandığı `MKT.L()` ile BİREBİR aynı çözümlemeyi yapmak
   zorunda (EXT sözlüğü dahil) — aşağıda L'nin kendisi çağrılıyor.
   ===================================================================== */
const LANG_SET = new Set(["en", "tr", "de", "fr", "es", "it", "pt", "ar"]);
const isLangMap = (o) =>
  !!o && typeof o === "object" && !Array.isArray(o) &&
  Object.keys(o).length > 0 && Object.keys(o).every((k) => LANG_SET.has(k));

/* Dilimlenmeyecek alanlar: kod bunları DİLDEN BAĞIMSIZ ANAHTAR olarak
   kullanıyor (blog kategori filtresi `b.cat.en` üzerinden eşleşiyor, ikon
   eşlemesi de öyle). Dilimlenirse anahtar dile göre değişir ve filtre çöker.
   Aynısı `name` için de geçerli: pages-solution.jsx başlığı `L(meta.name, 'en')`
   ile SABİT İngilizce adı okuyor; dilimlenirse o çağrı yerel adı döndürür ve
   Arapça/Almanca sayfalarda başlık değişir.
   Maliyeti birkaç KB; doğruluğu bozmaya değmez. */
const KEEP_LANGMAP = new Set(["cat", "name"]);

function sliceLocale(node, lc, key) {
  if (isLangMap(node)) return KEEP_LANGMAP.has(key) ? node : window.MKT.L(node, lc);
  if (Array.isArray(node)) return node.map((n) => sliceLocale(n, lc, key));
  if (node && typeof node === "object") {
    const r = {};
    for (const k in node) r[k] = sliceLocale(node[k], lc, k);
    return r;
  }
  return node;
}

/** /<locale>/<route>/<arg> → { locale, route, arg } (MarketingV2 ile aynı biçim). */
function routeOf(pathname) {
  const seg = (pathname || "/").replace(/^\/+|\/+$/g, "").split("/");
  const locale = LANG_SET.has(seg[0]) ? seg[0] : "en";
  return { locale, route: seg[1] || "home", arg: seg[2] || null };
}

/** Yalnız detay sayfasında okunan ağır alanlar. */
/* Yalnız `body` kırpılır ve yalnız ONA dokunulur.
   Modül `caps`/`flows` ve çözüm `pains`/`proof`/`testimonial` alanları BİLEREK
   kırpılmıyor: bu alanlar bileşenlerde `d.proof.value`, `d.pains.map(...)` gibi
   DOĞRUDAN okunuyor. Kırpılınca site içi gezinmede (menüden çözüm seçmek)
   `null.value` atıyordu ve sayfa beyaz kalıyordu — doğrudan açılışta çalıştığı
   için staging'de görülmedi. Kazançları da küçüktü (~6 KB gzip); gövdelerin
   948 KB'lık kazancı zaten alınıyor. */
const HEAVY = {
  blog: { key: "slug", route: "blog-post", fields: ["body"] },
  helpArticles: { key: "slug", route: "help-article", fields: ["body"] },
  legal: { key: "slug", route: "legal", fields: ["body"] },
};

function scopeToPage(content, route, arg) {
  const out = Object.assign({}, content);
  for (const [coll, cfg] of Object.entries(HEAVY)) {
    const list = content[coll];
    if (!Array.isArray(list)) continue;
    out[coll] = list.map((item) => {
      const current = route === cfg.route && arg && item[cfg.key] === arg;
      if (current) return item;
      const copy = Object.assign({}, item);
      // Kırpılan kayıt İŞARETLENİR: tüketici "gövde boş" ile "gövde henüz
      // gelmedi"yi ayırt edebilsin. Ayırt edemezse blog sayfası yedek
      // (fallback) makaleyi çizip YANLIŞ içerik gösterir.
      for (const f of cfg.fields) if (f in copy) copy[f] = Array.isArray(copy[f]) ? [] : null;
      copy.__partial = true;
      return copy;
    });
  }
  return out;
}

// Modül/çözüm objeleri zaten tüm alanları taşıyor; detay sözlükleri onlardan
// türetilir. Eskiden bu üçü de ayrıca gömülüyordu → her sayfada 280 KB tekrar.
function deriveLookups(MKT) {
  const modules = (MKT.content && MKT.content.modules) || [];
  const solutions = (MKT.content && MKT.content.solutions) || [];
  MKT.featureDetails = Object.fromEntries(
    modules.map((m) => [m.id, { intro: m.intro, caps: m.caps || [], related: m.related || [] }])
  );
  MKT.flows = Object.fromEntries(modules.map((m) => [m.id, m.flows || []]));
  MKT.solutionDetails = Object.fromEntries(solutions.map((s) => [s.id, s]));
  return MKT;
}

// react-snap, capture'dan hemen önce window.snapSaveState()'i çağırır ve dönen
// objeyi statik HTML'e <script>window.snapStore=...</script> olarak gömer. Böylece
// prerender edilmiş sayfa client'ta AÇILIRKEN veriyi yeniden fetch etmez —
// re-render anında olur (createRoot "wipe" gecikmesi yok), prod API yavaş/uzaksa
// bile ilk boya hızlı.
function registerSnapSave(MKT) {
  if (typeof window === "undefined") return;
  // D-212 F2: featureDetails / flows / solutionDetails GÖMÜLMEZ — üçü de
  // content.modules ve content.solutions'tan birebir türetiliyordu (280 KB
  // saf tekrar). Artık deriveLookups() ile okundukları anda üretiliyorlar.
  window.snapSaveState = () => {
    const { locale, route, arg } = routeOf(window.location.pathname);
    return {
      __MKT__: {
        content: sliceLocale(scopeToPage(MKT.content, route, arg), locale),
        storefronts: sliceLocale(MKT.storefronts, locale),
        __locale: locale,
        __scope: route + (arg ? "/" + arg : ""),
      },
    };
  };
}

export async function loadMarketingData() {
  const MKT = (window.MKT = window.MKT || {});

  // Prerender'da gömülen veri varsa: ağ isteği YOK, senkron kullan.
  // (react-snap snapSaveState() anahtarlarını ayrı window global'i olarak enjekte
  //  eder → window.__MKT__, window.snapStore değil.)
  if (window.__MKT__) {
    Object.assign(MKT, window.__MKT__);
    deriveLookups(MKT);
    registerSnapSave(MKT);
    return MKT.content;
  }

  const [home, blog, help, packages, legal] = await Promise.all([get("/home"), get("/blog"), get("/help"), get("/packages"), get("/legal")]);
  const modules = (home && home.modules) || [];
  const solutions = (home && home.solutions) || [];

  // Frontend'de eklenen "Paketler & Sepet" modülü (backend henüz seed etmiyor).
  // content.modules'a girince Home/Features kartı, feature DETAY sayfası, SEO
  // featureList ve solution modül-ekranları OTOMATİK gelir.
  const BUNDLES_MODULE = {
    id: "bundles", seo: "bundles", icon: "shopping-cart", color: "#7a4ddb", order: 50,
    name: { en: "Bundles & Cart", tr: "Paketler & Sepet" },
    tagline: { en: "Rent several products in one contract — bundled, priced and checked out.", tr: "Birden çok ürünü tek sözleşmede kirala — paketle, fiyatla, ödet." },
    blurb: { en: "Multi-product cart, named bundles and per-product add-ons — across your booking site and the back office.", tr: "Rezervasyon siteniz ve panelde çok ürünlü sepet, adlandırılmış paketler ve ürüne özel ek ürünler." },
    desc: { en: "Let customers build a cart of several products, attach add-ons to each, and sell pre-priced bundles — with one contract and the right total. Works on your white-label booking site and in the operator panel.", tr: "Müşteriler birden çok ürünü sepete eklesin, her birine ek ürün bağlasın ve ön-fiyatlı paketler satın — tek sözleşme ve doğru toplamla. Hem white-label rezervasyon sitenizde hem operatör panelinde çalışır." },
    points: {
      en: ["Multi-product contract with per-item dates & quantity", "Named bundles priced as a unit (fixed price or % off)", "Sector-specific add-ons attached per product", "Live cart totals, deposit and promo codes", "Same engine on the booking site and the back office"],
      tr: ["Ürün başına tarih & adetli çoklu ürün sözleşmesi", "Birim fiyatlı adlandırılmış paketler (sabit fiyat ya da % indirim)", "Ürüne bağlı sektöre özel ek ürünler", "Canlı sepet toplamı, depozito ve promosyon kodları", "Rezervasyon sitesi ve panelde aynı motor"],
    },
    intro: { en: "Increase average order value: bundle products, attach add-ons and sell packages. Build a bundle once and use it across every channel.", tr: "Ortalama sipariş değerini artırın: ürünleri paketleyin, ek ürün bağlayın ve paket satın. Paketi bir kez kurun, her kanalda kullanın." },
    caps: [
      { icon: "layers", t: { en: "Multi-product cart", tr: "Çoklu ürün sepeti" }, d: { en: "Add several products to one rental — each with its own dates and quantity.", tr: "Tek kiralamaya birden çok ürün ekleyin — her biri kendi tarih ve adediyle." } },
      { icon: "package", t: { en: "Named bundles", tr: "Adlandırılmış paketler" }, d: { en: "Create packages (e.g. ‘Family weekend’) priced as a unit — fixed price or % off.", tr: "‘Aile hafta sonu’ gibi paketler oluşturun, birim fiyatlayın — sabit ya da % indirim." } },
      { icon: "shopping-cart", t: { en: "Add-ons per product", tr: "Ürüne özel ek ürün" }, d: { en: "Helmet with a bike, child seat with a car, skipper with a yacht.", tr: "Bisikletle kask, arabayla çocuk koltuğu, yatla kaptan." } },
      { icon: "percent", t: { en: "Smart pricing", tr: "Akıllı fiyatlama" }, d: { en: "Bundle discounts, length-of-rental tiers, deposit and promo codes.", tr: "Paket indirimleri, süre kademeleri, depozito ve promosyon kodları." } },
    ],
    related: ["reservations", "contracts", "website"],
    flows: [
      { t: { en: "Build the bundle", tr: "Paketi kur" }, d: { en: "Name a package, add products and add-ons, set its price.", tr: "Pakete ad verin, ürün ve ek ürün ekleyin, fiyatını belirleyin." }, s: "bundles" },
      { t: { en: "Customer adds to cart", tr: "Müşteri sepete ekler" }, d: { en: "On the booking site: choose products, add-ons and a bundle.", tr: "Rezervasyon sitesinde: ürün, ek ürün ve paket seçer." }, s: "website" },
      { t: { en: "Checkout into one contract", tr: "Tek sözleşmeye ödeme" }, d: { en: "Totals, deposit and promo applied; one reservation is created.", tr: "Toplam, depozito ve promosyon uygulanır; tek rezervasyon oluşur." }, s: "reservations" },
    ],
  };
  if (!modules.some((m) => m.id === "bundles")) modules.push(BUNDLES_MODULE);
  // Not: bundles çapraz bir özellik; sektör çözümlerinin "modüller" grid'ine eklenmez
  // (oradaki kartlarda "Daha fazla" linki var, sektör modülleriyle karışmasın).

  MKT.content = {
    modules,
    heroSlides: (home && home.heroSlides) || [],
    solutions,
    packages: packages || [],
    stats: (home && home.stats) || [],
    steps: (home && home.steps) || [],
    testimonials: (home && home.testimonials) || [],
    faqs: (home && home.faqs) || [],
    blog: blog || [],
    helpCategories: (help && help.categories) || [],
    helpArticles: (help && help.articles) || [],
    legal: legal || [],
  };
  MKT.storefronts = STOREFRONTS;
  deriveLookups(MKT);
  registerSnapSave(MKT);
  return MKT.content;
}

/* ---------------------------------------------------------------------
   Site içi gezinme: gömülen veri o sayfaya göre kırpıldığı için, kullanıcı
   BAŞKA bir detay sayfasına geçtiğinde eksik alan tek uçtan tamamlanır.
   Uçlar backend'de zaten vardı; yeni API yazılmadı.
   Prerender'lı ilk açılışta hiç çağrılmaz (o sayfanın verisi zaten tam).
   ------------------------------------------------------------------- */
const DETAIL = {
  "blog-post": { coll: "blog", key: "slug", url: (a) => "/blog/" + a, need: "body" },
  "help-article": { coll: "helpArticles", key: "slug", url: (a) => "/help/" + a, need: "body" },
  legal: { coll: "legal", key: "slug", url: (a) => "/legal/" + a, need: "body" },
  feature: { coll: "modules", key: "id", url: (a) => "/modules/" + a, need: "caps" },
  solution: { coll: "solutions", key: "id", url: (a) => "/solutions/" + a, need: "faqs" },
};

const filled = new Set();

export async function ensureRouteData(route, arg) {
  const cfg = DETAIL[route];
  const MKT = window.MKT;
  if (!cfg || !arg || !MKT || !MKT.content) return false;
  const key = route + "/" + arg;
  if (filled.has(key)) return false;
  const list = MKT.content[cfg.coll];
  if (!Array.isArray(list)) return false;
  const i = list.findIndex((x) => x[cfg.key] === arg);
  if (i < 0) return false;
  const cur = list[i][cfg.need];
  const empty = cur == null || (Array.isArray(cur) && cur.length === 0);
  if (!empty) return false; // veri zaten tam

  const rec = await get(cfg.url(arg));
  if (!rec) return false;
  list[i] = Object.assign({}, list[i], rec, { __partial: false });
  filled.add(key);
  deriveLookups(MKT); // modules/solutions değiştiyse sözlükler tazelenmeli
  return true;
}
